import { hasSpellCheckErrors } from '../utils';
import { showSpellCheckSuggestions } from '../popup';

/**
 * Handle right-click on textbox for spell check
 * @param {Event} originalEvent - Original DOM event
 * @param {fabric.Textbox} textbox - The textbox object
 */
export function handleTextboxRightClick(originalEvent, textbox) {
  // Only handle if textbox has spell check errors
  if (!textbox || textbox.type !== 'textbox' || !hasSpellCheckErrors(textbox)) {
    return;
  }

  // Prevent default browser context menu and event propagation
  originalEvent.preventDefault();
  originalEvent.stopPropagation();
  originalEvent.stopImmediatePropagation &&
    originalEvent.stopImmediatePropagation();

  // Create a synthetic event object for the popup
  const syntheticEvent = {
    clientX: originalEvent.clientX,
    clientY: originalEvent.clientY,
    preventDefault: () => originalEvent.preventDefault(),
    stopPropagation: () => originalEvent.stopPropagation(),
  };

  // Always show the comprehensive popup (same as "Correggi" button)
  showSpellCheckSuggestions(textbox, syntheticEvent);
}
